export const headerVariants = {
  database: "database",
  groups: "groups",
  giving: "giving",
  signups: "signups",
  tools: "tools",
};
